import { render, staticRenderFns } from "./frontend.vue?vue&type=template&id=c93515a4&scoped=true&"
import script from "./frontend.vue?vue&type=script&lang=js&"
export * from "./frontend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c93515a4",
  null
  
)

export default component.exports